import React from "react";

export const Services = (props) => {
  return (
    <div id="services">
      <div className="container">
        <div className="section-title text-center">
          <h2>Our Services</h2>
          <p style={{ textAlign: "text-center" }}>
            Connecting Exceptional Talent with Visionary Employers.
          </p>
        </div>
        <div className="row">
  {props.data
    ? props.data.map((d, i) => (
        <div key={`${d.name}-${i}`} className="col-md-4 text-center">
          <img
            src={d.icon}
            alt={d.name}
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <div className="service-desc">
            <h3>{d.name}</h3>
            <p style={{ textAlign: "justify" }}>{d.text}</p>
          </div>
        </div>
      ))
    : "loading"}
</div>

      </div>
    </div>
  );
};
